import { SWReactCountryIcons } from "@similarweb/icons";
import { Flex } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";
import type { ICountryObject } from "app/services/CountryService";

import type { CrmEnrichmentI18nKeys } from "../../../types/translations";
import type {
    CrmEnrichmentJobObject,
    CrmEnrichmentJobRefreshPeriod,
    CrmEnrichmentJobType,
    CrmEnrichmentSource,
} from "../../../types/types";

import {
    StyledCaption,
    StyledCrmEnrichmentJobReviewSetting,
    StyledCrmEnrichmentJobReviewSettingsBlock,
    StyledValueText,
} from "./styles";

type Props = {
    selectedJobType: CrmEnrichmentJobType | "";
    selectedJobObject: CrmEnrichmentJobObject | "";
    selectedCountry: ICountryObject;
    selectedJobRefreshPeriod: CrmEnrichmentJobRefreshPeriod;
    selectedEnrichmentSource: CrmEnrichmentSource;
    translationKeys: CrmEnrichmentI18nKeys;
};

const CrmEnrichmentJobReviewSettings = ({
    selectedJobType,
    selectedJobObject,
    selectedJobRefreshPeriod,
    selectedEnrichmentSource,
    selectedCountry,
    translationKeys,
}: Props) => {
    const translate = useTranslation();

    return (
        <StyledCrmEnrichmentJobReviewSettingsBlock data-automation="settings-list">
            <StyledCrmEnrichmentJobReviewSetting>
                <StyledCaption>{translate("si.crm-enrichment.job-wizard.review.object")}</StyledCaption>

                <StyledValueText>{translate(translationKeys.object(selectedJobObject))}</StyledValueText>
            </StyledCrmEnrichmentJobReviewSetting>

            <StyledCrmEnrichmentJobReviewSetting>
                <StyledCaption>
                    {translate("si.crm-enrichment.job-wizard.settings.enrichment-level.caption")}
                </StyledCaption>

                <StyledValueText>
                    {translate(translationKeys.enrichmentSource(selectedEnrichmentSource))}
                </StyledValueText>
            </StyledCrmEnrichmentJobReviewSetting>

            {selectedJobType === "scheduled" ? (
                <StyledCrmEnrichmentJobReviewSetting>
                    <StyledCaption>{translate("si.crm-enrichment.job-wizard.settings.refresh.caption")}</StyledCaption>

                    <StyledValueText>
                        {translate(translationKeys.refreshPeriod(selectedJobRefreshPeriod))}
                    </StyledValueText>
                </StyledCrmEnrichmentJobReviewSetting>
            ) : null}

            <StyledCrmEnrichmentJobReviewSetting>
                <StyledCaption>{translate("si.crm-enrichment.job-wizard.settings.traffic.caption")}</StyledCaption>

                <Flex gap="6px">
                    <SWReactCountryIcons
                        size="xs"
                        countryCode={selectedCountry.id}
                    />

                    <StyledValueText>{selectedCountry.text}</StyledValueText>
                </Flex>
            </StyledCrmEnrichmentJobReviewSetting>
        </StyledCrmEnrichmentJobReviewSettingsBlock>
    );
};

export default CrmEnrichmentJobReviewSettings;
